'use client'
import HotelDesktopPageShell from '@/src/components/common/hotels/pageShell/hotelDesktopPageShell'
import { useIsHeya } from '@/src/hooks/useThemeKey'
import { Offer } from '@/src/types/offers'
import { getBrandName } from '@/src/utils/buildUtils'
import { useTranslations } from 'next-intl'
import HotelsHomeDesktop from './home'

interface HotelsHomeDesktopContainerProps {
    locale: string
    domainCountry?: string
    offers: Offer[]
    showVisaTab?: boolean
    showFlightsHotelsTab?: boolean
    showHolidaysTab?: boolean
}

const HotelsHomeDesktopContainer = ({
    locale,
    domainCountry,
    offers,
    showVisaTab = false,
    showFlightsHotelsTab = false,
    showHolidaysTab = false
}: HotelsHomeDesktopContainerProps) => {
    const t = useTranslations('hotels')
    const tHeadings = useTranslations('homePage.headings')
    const tVariants = useTranslations('variants')
    const isHeya = useIsHeya()
    const tagline = tHeadings('subHeading', { brandName: tVariants(getBrandName()) })

    return (
        <HotelDesktopPageShell identifier="hotels-home-desktop" domainCountry={domainCountry}>
            <HotelsHomeDesktop
                title={t('homeTitle')}
                subtitle={t('homeSubtitle')}
                tagline={tagline}
                offers={offers}
                locale={locale}
                showVisaTab={showVisaTab}
                showFlightsHotelsTab={showFlightsHotelsTab}
                showHolidaysTab={showHolidaysTab}
                heyaCopy={
                    isHeya
                        ? {
                            badge: t('heya.badge'),
                            headingLead: t('heya.headingLead'),
                            headingAccent: t('heya.headingAccent'),
                            intro: t('heya.intro')
                        }
                        : undefined
                }
            />
        </HotelDesktopPageShell>
    )
}

export { HotelsHomeDesktopContainer }
export default HotelsHomeDesktopContainer
